import React from "react";
import { includes } from "lodash";
import { Tag } from "primereact/tag";
import { useTranslation } from "react-i18next";

const OrderDamageCaseStatus = (props: any) => {
    const { status } = props;
    const { t } = useTranslation();

    if (!status) {
        return null;
    }

    // Success for accepted and closed
    if (includes(['accepted', 'closed'], status)) {
        return <Tag value={t(status)} severity="success" className="text-capitalize" />;
    }

    // Danger for rejected
    if (includes(['rejected'], status)) {
        return <Tag value={t(status)} severity="danger" className="text-capitalize" />;
    }

    // Warning for pending and re-opened
    if (includes(['pending', 're-opened'], status)) {
        return <Tag value={t(status)} severity="warning" className="text-capitalize" />;
    }

    // Contrast for in-progress
    if (includes(['in-progress'], status)) {
        return <Tag value={t(status)} severity="info" className="text-capitalize" />;
    }

    // Info for open
    if (includes(['open'], status)) {
        return <Tag value={t(status)} severity="info" className="text-capitalize" />;
    }

    // Secondary for archived
    if (includes(['archived'], status)) {
        return <Tag value={t(status)} severity="warning" className="text-capitalize" />;
    }

    // Default
    return <Tag value={t(status)} severity="warning" className="text-capitalize" />;
};

export default OrderDamageCaseStatus;

